import { Box, ColorOptions, ModBox, Spacer, Text, TextInput } from '@jfs/ui-new'
import { useEffect, useRef, useState } from 'react'
import { TextInput as RNTextInput } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'
import { Colors } from '../../util/util'
import { Note } from './Note'

export const ResetFormInput = ({
  setFieldValue,
  fieldName,
  label,
  leftComponent,
  rightComponent,
  maxLength,
  touched,
  error,
  innerRef,
  onFocus,
  onBlur,
  height = 64,
  labelFontSize = 16,
  selectedAppLanguage,
  ...props
}: any) => {
  const [showError, setShowError] = useState(false)
  const [isFocused, setFocused] = useState(false)
  const [isPressed, setPressed] = useState(false)
  const errorTimerRef = useRef<any>(0)
  const textInputRef = useRef<RNTextInput>(null)
  const refUsed = innerRef ?? textInputRef
  const onChangeText = (val) => {
    if (fieldName && setFieldValue) {
      setFieldValue(fieldName, val)
    }
  }
  const onPress = () => {
    if (refUsed.current) {
      refUsed.current.focus()
    }
  }
  const onInternalFocus = () => {
    setFocused(true)
    if (onFocus) {
      onFocus()
    }
  }
  const onInternalBlur = () => {
    setFocused(false)
    if (onBlur) {
      onBlur()
    }
  }

  const isError = !isFocused && touched && !!error && !isPressed
  useEffect(() => {
    if (isError) {
      errorTimerRef.current = setTimeout(() => {
        setShowError(true)
      }, 500)
    } else {
      clearTimeout(errorTimerRef.current)
      setShowError(false)
    }
  }, [isError])

  return (
    <Box>
      <Box position={'absolute'} zIndex={1} top={-12} bg={'WHITE'} left={16} h={24} ph={3}>
        <Text
          title={label}
          fontSize={labelFontSize}
          fontFamily={'JioType-Medium'}
          lineHeight={24}
          color={Colors.BLACK_14 as ColorOptions}
        />
      </Box>
      <Box
        h={height}
        borderWidth={1}
        ph={16}
        borderRadius={8}
        justify={'center'}
        borderColor={showError ? ('#E30513' as ColorOptions) : isFocused ? Colors.PRIMARY : 'BLACK'}>
        <TextInput
          onChangeText={onChangeText}
          minHeight={56}
          rightComponent={rightComponent}
          leftComponent={leftComponent}
          showBottomLine={false}
          fontFamily={'JioType-Medium'}
          fontWeight={'600'}
          fontSize={16}
          lineHeight={24}
          color={Colors.BLACK_14 as ColorOptions}
          maxLength={maxLength}
          touched={true}
          onPress={onPress}
          onPressIn={() => {
            setPressed(true)
          }}
          onPressOut={() => {
            setPressed(false)
          }}
          onFocus={onInternalFocus}
          onBlur={onInternalBlur}
          innerRef={refUsed}
          {...props}
          error={undefined}
        />
      </Box>
      <ModBox pt={12} show={!showError}>
        <Note selectedAppLanguage={selectedAppLanguage} />
      </ModBox>
      {showError && (
        <Box pt={12} flexDirection={'row'} align={'center'} pr={30}>
          <SvgImage imageName="WarningIconError" color={'#E30513'} />
          {/* <Icon id={'INFO'} color={'#E30513' as ColorOptions} size={16} /> */}
          <Spacer direction={'horizontal'} size={4} />
          <Text
            testID={'textInputErrorId'}
            color={'#E30513' as ColorOptions}
            fontFamily={'JioType-Medium'}
            fontSize={12}
            lineHeight={16}
            letterSpacing={-0.06}>
            {error}
          </Text>
        </Box>
      )}
    </Box>
  )
}
